<script setup lang="ts">
import usersPicture01 from '@/assets/images/landing/MFT2024_guest_01.webp'
import usersPicture02 from '@/assets/images/landing/MFT2024_guest_02.webp'
import usersPicture03 from '@/assets/images/landing/MFT2024_guest_03.webp'
import usersPicture04 from '@/assets/images/landing/MFT2024_guest_04.webp'
import usersPicture05 from '@/assets/images/landing/MFT2024_guest_05.webp'
import usersPicture06 from '@/assets/images/landing/MFT2024_guest_06.webp'
import usersPicture07 from '@/assets/images/landing/MFT2024_guest_07.webp'
import usersPicture08 from '@/assets/images/landing/MFT2024_guest_08.webp'
import usersPicture09 from '@/assets/images/landing/MFT2024_guest_09.webp'
import usersPicture10 from '@/assets/images/landing/MFT2024_guest_10.webp'
import { testimonials } from '@/data/testimonials'

// お客様の声は外部データモジュールから読み込む（非エンジニアが編集しやすいように）。
// 追加・修正は `data/testimonials.ts` の配列を編集するだけでよい。
// #737: このセクションは子供・保護者・講師の声のみ（audience === 'kid'）。
// 大人（ベーマガ世代）の声は各セクションに静置する LandingVoiceCard へ分離した。
const usersVoices = testimonials.filter(t => t.audience === 'kid')

const usersPictures = ref([
  { src: usersPicture01, alt: 'ユーザーボイス1' },
  { src: usersPicture02, alt: 'ユーザーボイス2' },
  { src: usersPicture03, alt: 'ユーザーボイス3' },
  { src: usersPicture04, alt: 'ユーザーボイス4' },
  { src: usersPicture05, alt: 'ユーザーボイス5' },
  { src: usersPicture06, alt: 'ユーザーボイス6' },
  { src: usersPicture07, alt: 'ユーザーボイス7' },
  { src: usersPicture08, alt: 'ユーザーボイス8' },
  { src: usersPicture09, alt: 'ユーザーボイス9' },
  { src: usersPicture10, alt: 'ユーザーボイス10' },
])

// #737: / から title / intro を差し替える。未指定は旧 / の文言（現在は未使用の互換）。
interface Props {
  title?: string
  intro?: string[]
}
const props = withDefaults(defineProps<Props>(), {
  title: 'プログラミング教育にもおすすめです',
  intro: () => [
    '子供はゲームが大好き。',
    '家でもスマホでもすごいゲームがすぐできてしまう現代だからこそあえて、ゲームを作ることを教えてあげたいと思いませんか？',
  ],
})
</script>

<template>
  <div class="black py-8">
    <div class="centered-area">
      <h2>{{ props.title }}</h2>
      <p
        v-for="(line, i) in props.intro"
        :key="i"
      >
        {{ line }}
      </p>
    </div>

    <LandingTestimonialMarquee
      :voices="usersVoices"
      class="mt-4"
    />

    <div
      class="marquee-right"
      style="margin-top: 2px;"
    >
      <div class="marquee-content">
        <div
          v-for="item in usersPictures"
          :key="item.alt"
          class="marquee-item"
        >
          <v-img
            :src="item.src"
            height="100%"
            cover
          />
        </div>
        <div
          v-for="item in usersPictures"
          :key="item.alt"
          class="marquee-item"
        >
          <v-img
            :src="item.src"
            height="100%"
            cover
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.black {
  background-color: var(--landing-color-dark-bg);
  color: white;
}

/* Add text shadow to sign-in button to make it more visible */
.v-btn[to="/signin"] {
  text-shadow: 0 0 0.3em rgba(0, 0, 0, 0.9);
  font-weight: 600;
}

@media (max-width: 600px) {
  .story {
    padding-top: 24px;
  }
}

@media (min-width: 600.02px) {
  .story {
    padding-top: 64px;
  }
}

.story p {
  font-weight: 400 !important;
  /* font-size: 1.1em !important; */
  font-size: clamp(1rem, 1.1vw, 1.2rem) !important;
  margin-bottom: 0.7em;
}

.story table {
  font-size: 140% !important;

  text-align: center;

  margin-bottom: 0.7em;
  width: 100%;
}

.story table th,
td {
  padding: 0.5em;
  margin: 0.2em 1em;
  border-bottom: 1px solid black;
}

.story .small-notes {
  font-size: 70% !important;
}

.story .story-image {
  width: 40%;
  height: auto;
  margin: 8px;
  border-radius: var(--landing-radius);
}

.story li {
  /* list-style-type: disc; */
  margin-left: 2em;
}

.register-form {
  background-color: #f7f7f7;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);

  border-radius: var(--landing-radius);
  padding: 1em;
}

/*
    .encodia {
      background-image: url("@/assets/images/landing/landing_bg_800x533.webp");
      background-size: cover;
      background-color: bisque;
      border-radius: 8px;
      box-shadow: 2px 2px 2px rgba(0, 0, 0, 0.5);

      font-family: "Utsukushi" !important;

      padding: 1em 1em;
    }

    .encodia p {
      font-size: 1.3em !important;
    }
    */

.smallnote {
  font-size: 0.8em !important;
  line-height: 1em;
}

.cancelled {
  text-decoration: line-through;
}

.youtube-outer {
  height: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
}

.youtube-inner {
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.5);

  width: 96vw;
  height: 54vw;
  max-width: 864px;
  max-height: 486px;
  /* background-color: lightgray; */
}

div.youtube-mark {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.users-voice {
  background-color: #ffffff00;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}

.users-voice-inner {
  background-color: #455a64a0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* height: 100%; */
  padding: 4px;
}

@media (max-width: 600px) {
  .users-voice-paragragh {
    /* font-family: 'Noto Sans JP', sans-serif !important; */
    font-weight: 900 !important;
    font-size: 2.5rem !important;
    line-height: 3rem;

    color: white;
    text-shadow: 0 0 0.3em rgba(0, 0, 0, 0.9);
    text-align: center;
    margin: 8px;
  }
}

@media (min-width: 600.02px) {
  .users-voice-paragragh {
    /* font-family: 'Noto Sans JP', sans-serif !important; */
    font-weight: 900 !important;
    font-size: 3rem !important;
    line-height: 3.5rem;

    color: white;
    text-shadow: 0 0 0.3em rgba(0, 0, 0, 0.9);
    text-align: center;
    margin: 8px;
  }
}

.relative-area {
  position: relative;
  width: 100%;
  overflow: hidden;

  /* background-color: #00ffff80; */

  /* cursor: none; */
}

.absolute-area {
  position: absolute;
  /* top: 25%; */
  /* width: 100%; */
}

.centered-area {
  width: 100%;
  height: 100%;
  max-width: var(--landing-max-width);
  margin: auto;
  padding: var(--landing-gutter);
}

.centered-area h2 {
  font-size: var(--landing-h2-size);
  font-weight: 700;
  text-align: center;
  margin-top: 0;
  margin-bottom: 0.5em;
}

.centered-area h3 {
  font-family: 'Noto Sans JP', sans-serif;
  font-size: var(--landing-h3-size);
  font-weight: 500;
  text-align: center;
  margin-bottom: 0.5em;
}

.centered-area p {
  margin-bottom: 0.5em;
  /* #737: 見出し（中央）に合わせ、子供セクションの説明文も中央揃えにする */
  text-align: center;
}

.centered-area ul {
  padding-left: 1.5em;
}

section div.rounded-area {
  margin: 0 0.5em;
  padding: var(--landing-rounded-padding);

  color: var(--landing-color-text-dark);
  background-color: #ffffff;
  border-radius: var(--landing-radius);
}

.rounded-area h3 {
  /* color: #333333; */
  font-size: 2em;
  text-align: center;
  margin-bottom: 0.7em;
}

.marquee-content {
  display: inline-flex;
  animation: marquee 40s linear infinite;
}

.marquee-item {
  /* width: 300px; */
  width: clamp(166.7px, 23.44dvw, 300px);
  /* height: 300px; */
  aspect-ratio: 1 / 1;
  margin: 0 1px;
  color: #f0f0f0;
  background-color: #ffffff10;
}

.marquee-item .v-card-text {
  font-size: clamp(12.22px, 1.72dvw, 22px);
  /* font-weight: 700; */
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(-50%);
  }
}

.marquee-left .marquee-content {
  overflow: hidden;
  /* white-space: nowrap; */
  animation-direction: normal;
}

.marquee-right .marquee-content {
  overflow: hidden;
  /* white-space: nowrap; */
  animation-direction: reverse;
}
</style>
